// reff: https://codesandbox.io/s/030657ovvn

/* eslint-disable */
import React from 'react';
import moment from 'moment';
import {
  DatePicker,
  Form,
  Input,
  Radio,
  Upload,
  Button,
  Select,
  InputNumber,
  Typography,
  Checkbox
} from 'antd';
import { useField } from 'formik';
// import { removeDot } from "./Number";
import { CloudDownloadOutlined } from '@ant-design/icons';

const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const Dragger = Upload.Dragger;
const { Password, TextArea, Search } = Input;
const { RangePicker } = DatePicker;
const DATE_FORMAT_LONG = 'YYYY-MM-DD';

const makeField = (Component) => ({
  tooltip,
  layout,
  input,
  label,
  labelEmpty,
  required,
  children,
  defaultValue,
  defaultChecked,
  hasFeedback,
  errorFeedback,
  successFeedback,
  formItemLayout,
  bot = false,
  style,
  ...rest
}) => {
  const [field, meta] = useField(rest);
  let format = {};
  let value = input?.value || undefined || defaultValue;
  const checked =
    input?.value !== undefined && input?.value !== '' ? input?.value : defaultChecked;

  const hasError = meta.error ? meta.touched && meta.error : false;
  const hasSuccess = !meta.error ? meta.touched && !meta.error : false;

  if (rest.type === 'email') {
    value = input?.value.split(' ').join('');
  }

  //   if (rest.type === 'money') {
  //     value = input?.value.split(' ').join('');
  //     format = {
  //       formatter: (value) =>
  //         !value
  //           ? ''
  //           : value === 'Rp'
  //           ? ''
  //           : `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.'),
  //       parser: (value) => removeDot(value, 'Rp '),
  //       step: 500,
  //     };
  //   }

  //   if (rest.type === 'upload') {
  //     field.onChange = null;
  //     format = {
  //       listType: 'picture',
  //       fileList: value,
  //     };
  //     children = (
  //       <>
  //         <p className="ant-upload-drag-icon">
  //           <CloudDownloadOutlined />
  //         </p>
  //         <Typography.Link>Unggah Gambar</Typography.Link>
  //         <br />
  //         <Typography.Text type="primary">
  //           Format Gambar : Jpg / Png <strong>328 x 160 px</strong>
  //         </Typography.Text>
  //       </>
  //     );
  //   }

  //   if (rest.type === 'percentage') {
  //     value = input?.value.split(' ').join('');
  //     format = {
  //       formatter: (value) => (!value ? '' : `${value}%`),
  //       parser: (value) => value.replace('%', ''),
  //     };
  //   }

  if (rest.type === 'date') {
    format = { format: DATE_FORMAT_LONG };
    value = value !== undefined ? moment(new Date(value), DATE_FORMAT_LONG) : null;
  }

  let setValue = { value };

  if (rest.type === 'checkbox') {
    setValue = { checked };
  }

  return (
    <FormItem
      label={label}
      validateStatus={hasError ? 'error' : 'success'}
      hasFeedback={hasFeedback && (hasError || hasSuccess)}
      help={hasError && meta.error}
      required={required}
      tooltip={tooltip}
      {...formItemLayout}
    >
      <Component
        style={{ marginBottom: bot && 20, ...style }}
        {...input}
        {...setValue}
        {...format}
        {...field}
        {...rest}
        children={children}
      />
    </FormItem>
  );
};

export const FormInput = makeField(Input);
export const FormInputArea = makeField(TextArea);
// export const FormInputNumber = makeField(InputNumber);
export const FormInputPassword = makeField(Password);
export const FormInputSearch = makeField(Search);
export const FormSelect = makeField(Select);
export const FormDatePicker = makeField(DatePicker);
// export const FormRangePicker = makeField(RangePicker);
export const FormRadioGroup = makeField(RadioGroup);
export const FormCheckbox = makeField(Checkbox);
// export const FormUpload = makeField(Upload);
// export const FormUploadDragger = makeField(Dragger);
// export const FormButton = makeField(Button);
// export const FormEditor = makeField(Editor);
